import React, { useEffect, useState } from "react";
import XCard from "../XCard";
import axios from "../../services/axios";
import FormList from "./FormList";
const CandidateForms = ({ candidate,getDoc,formData,formList, canSendNonAgentDocs }) => {

  return (
    <>
      {formList.length > 0  && (
        <FormList
          id={candidate._id}
          candidate={candidate}
          getDoc={getDoc}
          formData={formData}
          DateOfJoining={candidate?.DateOfJoining}
          canSendNonAgentDocs={canSendNonAgentDocs}
        />
      )}
    </>
  );
};

export default CandidateForms;
